export const pipelineEntityTypes = [
    "ReferenceContact",
    "ReferenceBusiness",
    "Community",
];
export const pipelineCardSorts = [
    "updatedAtDesc",
    "updatedAtAsc",
    "createdAtDesc",
    "createdAtAsc",
    "nameAsc",
    "nameDesc",
];
//# sourceMappingURL=pipeline.js.map